export default __webpack_public_path__ + "app/images/user/img-user-blue.svg";